// src/containers/Codes/deliveryCodes.js

import CodeSet from './CodeSet';

const deliveryCodes = new CodeSet('delivery', { fr: 'livraison', it: 'consegna', es: 'entrega', de: 'lieferung', da: 'levering', nl: 'levering', no: 'levering', sv: 'leverans' });

// Express (0)
deliveryCodes.addData(0, {
  name: { en: 'express', fr: 'express', it: 'espresso', es: 'exprés', de: 'express', da: 'ekspres', nl: 'express', no: 'ekspress', sv: 'express' },
  text: { en: '', fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }
});

// Commented out in the original file
// deliveryCodes.addData(1, {
//   name: { en: 'max. 7 days', fr: 'max. 7 jours', it: 'max. 7 giorni', es: 'máx. 7 días' },
//   text: { en: '', fr: '', it: '', es: '' }
// });
// deliveryCodes.addData(2, {
//   name: { en: 'max. 14 days', fr: 'max. 14 jours', it: 'max. 14 giorni', es: 'máx. 14 días' },
//   text: { en: '', fr: '', it: '', es: '' }
// });
// deliveryCodes.addData(3, {
//   name: { en: 'max. 30 days', fr: 'max. 30 jours', it: 'max. 30 giorni', es: 'máx. 30 días' },
//   text: { en: '', fr: '', it: '', es: '' }
// });
// deliveryCodes.addData(4, {
//   name: { en: 'max. 60 days', fr: 'max. 60 jours', it: 'max. 60 giorni', es: 'máx. 60 días' },
//   text: { en: '', fr: '', it: '', es: '' }
// });


export default deliveryCodes;
